// extracted by mini-css-extract-plugin
export default {"greeting":"Payment_greeting__KSw95","header":"Payment_header__gl1+G","cards":"Payment_cards__+9ByT"};